module.exports = __webpack_public_path__ + "img/logo.f6016842.png";